import { useMemo } from 'react';

import { MissionKindEnum } from '@e-socna/data-layer';

import { Wizard } from '../../components/Wizard';

import { FormVariant } from '../enums/variant.enum';
import { MissionFormTab } from '../Mission/enums/tab.enum';
import { useInitialValuesFactory } from '../Mission/hooks/useInitialValuesFactory.hook';
import { useMissionStepDefinitions } from '../Mission/hooks/useSteps.hook';
import { useMissionSubmit } from '../Mission/hooks/useSubmit.hook';
import { pickSteps } from '../Mission/utils/pick-steps.util';
import type { MissionCreationFormProps } from '../Mission/types/mission-creation-form-props.type';

// A collaboration has neither a mission type nor a collaboration.
const COLLABORATION_CREATION_TABS: readonly MissionFormTab[] = [
  MissionFormTab.GeneralInfo,
  MissionFormTab.Address,
  MissionFormTab.InternalActors,
  MissionFormTab.ExternalActors,
  MissionFormTab.CodingConfig,
];

export const CollaborationCreationForm = ({
  folderConsolidation,
}: Readonly<MissionCreationFormProps>) => {
  const { initialValues } = useInitialValuesFactory(
    undefined,
    MissionKindEnum.Composite,
  );

  const { handleSubmit } = useMissionSubmit({
    formVariant: FormVariant.Creation,
  });

  const definitions = useMissionStepDefinitions({
    folderConsolidation,
    formVariant: FormVariant.Creation,
    kind: MissionKindEnum.Composite,
  });
  const { steps, wizardChildren } = useMemo(
    () => pickSteps(definitions, COLLABORATION_CREATION_TABS),
    [definitions],
  );

  return (
    <Wizard
      askMemoBeforeSubmit
      formVariant={FormVariant.Creation}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      showCancelButton={false}
      steps={steps}
    >
      {wizardChildren}
    </Wizard>
  );
};
